// Polkadot AssetHub Testnet (Paseo) Configuration
export const NETWORK_CONFIG = {
  chainId: 420420422,
  chainIdHex: '0x190FC4E6',
  name: 'Paseo AssetHub Testnet',
  rpcUrl: 'https://testnet-passet-hub-eth-rpc.polkadot.io',
  explorerUrl: 'https://blockscout-passet-hub.parity-testnet.parity.io',
  nativeCurrency: {
    name: 'PAS',
    symbol: 'PAS',
    decimals: 18,
  },
  faucetUrl: 'https://faucet.polkadot.io/',
} as const;

// Zero address constant for comparison
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

// Contract addresses - Deployed to Paseo AssetHub Testnet (2026-01-13 - v3 with saveGame)
export const CONTRACT_ADDRESSES = {
  // Core contracts
  GAME: '0xa2961419A7212e62c09EC5CA950D4Bd978d67FEa' as string,      // CrystalsGame (main orchestrator)
  COMBAT: '0x88583d3485A4C66aD8634bfEA34a5Fd1d06Ef1F2' as string,
  PARTY: '0xa63a50F653E5EEBb674ee181254c4a6F4E695Aae' as string,
  WORLD: '0x7DF74000506fB3cB1F964B4ce85eE44c0911E52B' as string,
  MAGIC: '0xbb19685D9eEef3BC65167A46A9EF90655855472D' as string,

  // Data contracts
  CLASS_DATA: '0x156FB51C2E8a2C465693E7118A9422F29A133728' as string,
  ITEM_DATA: '0xA4060BB121218dd77F7EEE54954fdA60811110c0' as string,
  SPELL_DATA: '0x4faAdc06eEb95e9B383F3cD0b350b36125F7828c' as string,
  ENEMY_DATA: '0xdad0DE3CB4160A804a5b4340504ff2bf6be763B8' as string,

  // Systems
  RANDOMNESS: '0x853ff42150780B0534384933A9475e6117ee6e62' as string,
  SHOP: ZERO_ADDRESS as string,       // Not yet deployed
  INN: ZERO_ADDRESS as string,        // Not yet deployed
  TRANSPORT: ZERO_ADDRESS as string,  // Not yet deployed

  // NFT contracts
  SAVE_NFT: ZERO_ADDRESS as string,   // Not yet deployed
  ACHIEVEMENT_SBT: ZERO_ADDRESS as string, // Not yet deployed
};

// After deployment, update these addresses from:
// ../../../contracts/deployments/paseo.json

// Gas limits for different operations
export const GAS_LIMITS = {
  CREATE_GAME: 300000,
  MOVE: 50000,
  ATTACK: 80000,
  CAST_SPELL: 100000,
  USE_ITEM: 60000,
  FLEE: 40000,
  BUY_ITEM: 50000,
  SELL_ITEM: 40000,
  EQUIP_ITEM: 30000,
  REST: 60000,
} as const;

// Block explorer URL builder
export const getExplorerUrl = (type: 'tx' | 'address' | 'block', value: string): string => {
  switch (type) {
    case 'tx':
      return `${NETWORK_CONFIG.explorerUrl}/tx/${value}`;
    case 'address':
      return `${NETWORK_CONFIG.explorerUrl}/address/${value}`;
    case 'block':
      return `${NETWORK_CONFIG.explorerUrl}/block/${value}`;
    default:
      return NETWORK_CONFIG.explorerUrl;
  }
};

// Contract deployment info type
export interface DeploymentInfo {
  address: string;
  blockNumber: number;
  deployer: string;
  timestamp: number;
  transactionHash: string;
}

// Function to load deployment info from file
export const loadDeploymentInfo = async (): Promise<Record<string, DeploymentInfo> | null> => {
  try {
    // This would load from the deployment JSON file
    // For now, return null (will be implemented after deployment)
    return null;
  } catch (error) {
    console.error('Failed to load deployment info:', error);
    return null;
  }
};
